import * as React from 'react';

import { translate } from '~l10n/client';
import { IconButton } from '~shared/components/buttons';
import { IconX } from '~shared/components/icons/standard';

import { FileDropFileWrapper } from './FileDropFileWrapper';

interface FileDropProgressProps {
  fileName: string;
  loaded: number;
  total: number;
  lengthComputable: boolean;
  handleRemove: () => void;
}
export function FileDropProgress({
  fileName,
  loaded,
  total,
  lengthComputable,
  handleRemove,
}: FileDropProgressProps) {
  const progress =
    lengthComputable && total > 0 ? Math.round((loaded / total) * 100) : 0;

  return (
    <FileDropFileWrapper
      className="relative"
      fileName={
        <FileDropFileWrapper.FileName>
          <FileDropFileWrapper.TruncatedFileName
            fileName={fileName}
            className="text-sm font-medium"
          />
        </FileDropFileWrapper.FileName>
      }
      actions={
        <FileDropFileWrapper.Actions>
          <IconButton appearance="ghost" onClick={handleRemove}>
            <IconX title={translate('Remove')} titleId="file-drop-remove" />
          </IconButton>
        </FileDropFileWrapper.Actions>
      }
      progress={<FileDropFileWrapper.Progress progress={progress} />}
    />
  );
}
